<template>
  <v-dialog 
    v-model="value" 
    max-width="500" 
    persistent 
    transition="dialog-bottom-transition"
    overlay-color="primary"
    overlay-opacity="0.2"
  >
    <v-card class="modern-confirm-card overflow-hidden">
      <!-- Premium Header: Bespoke Style -->
      <div class="bg-grey-light pa-6 border-bottom">
        <div class="d-flex align-center">
          <v-avatar color="amber accent-4" size="44" class="mr-4 shadow-sm border-white-sm">
            <v-icon color="white" small>fas fa-exclamation-triangle</v-icon>
          </v-avatar>
          <div>
            <div class="text-h5 font-weight-black primary--text lh-1 uppercase-tracking">
              Confirmar Acción
            </div>
            <div class="caption grey--text font-weight-bold text-uppercase tracking-widest mt-1">
              Validación de Seguridad
            </div>
          </div>
        </div>
      </div>

      <!-- Main Body: Consistent Padding & Layout -->
      <v-card-text class="pa-8 pb-4">
        <div class="d-flex">
          <div class="body-1 primary--text font-weight-medium lh-1-6">
            {{ message || '¿Estás seguro de que deseas realizar esta operación? Esta acción podría ser irreversible.' }}
          </div>
        </div>

        <!-- <div class="modern-alert-info rounded-lg mt-6 pa-4 border-amber-light">
          <div class="d-flex align-center">
            <v-icon x-small color="amber darken-3" class="mr-2">fas fa-info-circle</v-icon>
            <span class="caption amber--text text--darken-4 font-weight-black uppercase">Nota del Sistema</span>
          </div>
          <p class="caption grey--text text--darken-2 mt-1 mb-0 lh-1-4">
            Al confirmar, los cambios se aplicarán inmediatamente en la base de datos de <strong>Runflow</strong>.
          </p>
        </div> -->
      </v-card-text>

      <!-- Footer Buttons: Aligned Right (Consistent with Mantenedores) -->
      <v-divider class="mx-8 opacity-10"></v-divider>
      <div class="pa-6 d-flex justify-end gap-3 actions-bg">
        <v-btn 
          text 
          class="modern-btn grey--text font-weight-bold text-none rounded-lg px-6"
          @click="$emit('cancel', value=false)"
        >
          Cancelar
        </v-btn>
        
        <v-btn 
          @click="confirmed" 
          color="success" 
          elevation="0"
          height="44"
          class="modern-btn white--text font-weight-black text-none rounded-lg px-8 shadow-sm"
        >
          Sí, Confirmar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Confirm',
  props: {
    value: { type: Boolean, default: false },
    message: { type: String, default: '' }
  },
  methods: {
    confirmed() {
      this.$emit('ok')
    }
  }
}
</script>

<style scoped>
.modern-confirm-card {
  border-radius: 12px !important;
  font-family: 'Outfit', sans-serif !important;
  background-color: white !important;
}

.bg-grey-light { background-color: #f8fafc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.border-white-sm { border: 2px solid white !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important; }
.uppercase-tracking { letter-spacing: -0.5px; text-transform: none; }
.tracking-widest { letter-spacing: 1.5px; }

.lh-1 { line-height: 1 !important; }
.lh-1-4 { line-height: 1.4 !important; }
.lh-1-6 { line-height: 1.6 !important; }

.gap-3 { gap: 12px; }

.modern-alert-info {
  background-color: #fffbeb;
  border: 1px solid #fef3c7;
}

.modern-btn {
  font-size: 0.9rem !important;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
}

.gradient-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
}

.modern-btn:hover {
  transform: translateY(-1px);
}

.opacity-10 { opacity: 0.1; }
</style>